import React from 'react';

function SelfPacedHeader() {
  return (
    <div className="d-flex pt-4 pb-3 w-100 justify-content-center sticky-top bg-light">
      <h1 className="display-1">Acumen</h1>
    </div>
  );
}

export default SelfPacedHeader;
